import { render, staticRenderFns } from "./counterpartiesUserBread.vue?vue&type=template&id=566322c5"
import script from "./counterpartiesUserBread.vue?vue&type=script&lang=js"
export * from "./counterpartiesUserBread.vue?vue&type=script&lang=js"
import style0 from "./counterpartiesUserBread.vue?vue&type=style&index=0&id=566322c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports